import { ITEM_TYPE, getPathname } from '@beef/shop-common';

import * as types from './eventTypes';
import { subscriprionSuccessName } from './constants';
import { getCommonFields } from './helpers';

const counter = 26001372;
const reachCounter = 26246625;
const reachCounterCommon = 28573041;

const paramsFuncName = 'params';
const reachGoalFuncName = 'reachGoal';

export default function pushToYM(type, data) {
  const { ym } = window || {};

  if (ym) {
    try {
      switch (type) {
        case types.ADD_TO_COMPARISON_FROM_CATALOG: {
          const yaParams = {
            compare_ev_: {
              add_to_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'addtocomparelist');
          break;
        }
        case types.REMOVE_FROM_COMPARISON_FROM_CATALOG: {
          const yaParams = {
            compare_ev_: {
              remove_from_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.ADD_TO_FAVORITE_FROM_CATALOG: {
          const yaParams = {
            wishlist_ev_: {
              add_to_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'addtowishlist');
          break;
        }
        case types.REMOVE_FROM_FAVORITE_FROM_CATALOG: {
          const yaParams = {
            wishlist_ev_: {
              remove_from_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.ADD_TO_COMPARISON_FROM_MODAL: {
          const yaParams = {
            compare_ev_: {
              add_to_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'addtocomparelist');
          break;
        }
        case types.REMOVE_FROM_COMPARISON_FROM_MODAL: {
          const yaParams = {
            compare_ev_: {
              remove_from_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.ADD_TO_FAVORITE_FROM_MODAL: {
          const yaParams = {
            wishlist_ev_: {
              add_to_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'addtowishlist');
          break;
        }
        case types.REMOVE_FROM_FAVORITE_FROM_MODAL: {
          const yaParams = {
            wishlist_ev_: {
              remove_from_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }

        case types.ADD_TO_COMPARISON_FROM_DETAILS_PAGE: {
          const yaParams = {
            compare_ev_: {
              add_to_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'addtocomparelist');
          break;
        }
        case types.REMOVE_FROM_COMPARISON_FROM_DETAILS_PAGE: {
          const yaParams = {
            compare_ev_: {
              remove_from_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.ADD_TO_FAVORITE_FROM_DETAILS_PAGE: {
          const yaParams = {
            wishlist_ev_: {
              add_to_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'addtowishlist');
          break;
        }
        case types.REMOVE_FROM_FAVORITE_FROM_DETAILS_PAGE: {
          const yaParams = {
            wishlist_ev_: {
              remove_from_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }

        case types.REMOVE_FROM_FAVORITE: {
          const yaParams = {
            wishlist_ev_: {
              remove_from_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.ADD_TO_FAVORITE: {
          const yaParams = {
            wishlist_ev_: {
              add_to_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(reachCounter, reachGoalFuncName, 'addtowishlist');
          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.REMOVE_FROM_FAVORITE_ALL: {
          const yaParams = {
            wishlist_ev_: {
              remove_all_from_wishlist: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.ADD_TO_COMPARISON: {
          const yaParams = {
            compare_ev_: {
              add_to_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(reachCounter, reachGoalFuncName, 'addtocomparelist');
          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.REMOVE_FROM_COMPARISON: {
          const yaParams = {
            compare_ev_: {
              remove_from_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.REMOVE_FROM_COMPARISON_ALL: {
          const yaParams = {
            compare_ev_: {
              remove_all_from_compare: [
                {
                  id: data?.id,
                  name: data?.name,
                  brand: data?.brand,
                  position: data?.position,
                  place: data?.place,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SELECT_TRADE_IN_DEVICE_TYPE: {
          const yaParams = {
            trade_in_ev_: {
              beeline_bid: {
                beeline_device: data.deviceType,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SELECT_TRADE_IN_DEVICE_BRAND: {
          const yaParams = {
            trade_in_ev_: {
              beeline_bid: {
                beeline_device: {
                  [data.deviceType]: {
                    brand: data.brand,
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SELECT_TRADE_IN_DEVICE_MODEL: {
          const yaParams = {
            trade_in_ev_: {
              beeline_bid: {
                beeline_device: {
                  [data.deviceType]: {
                    model: data.model,
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SELECT_TRADE_IN_DEVICE_CAPACITY: {
          const yaParams = {
            trade_in_ev_: {
              beeline_bid: {
                beeline_device: {
                  [data.deviceType]: {
                    storage: data.capacity,
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SELECT_TRADE_IN_MAX_PRICE: {
          const yaParams = {
            trade_in_ev_: {
              beeline_bid: {
                beeline_result: data.result,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          ym(reachCounter, reachGoalFuncName, 'TradeInBeelineResult');
          break;
        }
        case types.SELECT_TRADE_IN_TO_PURCHASE: {
          const yaParams = { trade_in_ev_: { beeline_bid: 'beeline_to_purchase' } };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_DEVICE_DETAILS_WITH_TRADE_IN: {
          const yaParams = {
            trade_in_ev_: {
              product_click: {
                [data.url]: {
                  productid: data.id,
                  name: data.name,
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCTS_SEEN_WITH_TRADE_IN: {
          const yaParams = {
            trade_in_ev_: {
              product_view: {
                [window.location.href]: data?.items?.map((item) => ({
                  productid: item.id,
                  name: item.title,
                })),
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_BEELINE_OFFICE_SERVICE: {
          const yaParams = { trade_in_ev_: { beeline_bid: 'beeline_tab_click' } };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_RANDOM_SERVICE: {
          const yaParams = { trade_in_ev_: { partner_bid: 'partner_tab_click' } };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_FAQ: {
          const yaParams = { trade_in_ev_: { faq: data.title } };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_MAIN_SLIDER_BANNER: {
          const yaParams = {
            banners_ev_: {
              view: {
                shop_main: {
                  position: {
                    [`carousel_${data.index}`]: {
                      [data.title]: data.url,
                    },
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.CLICK_MAIN_SLIDER_BANNER: {
          const yaParams = {
            banners_ev_: {
              click: {
                shop_main: {
                  position: {
                    [`carousel_${data.index}`]: {
                      [data.title]: data.url,
                    },
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_MAIN_STATIC_BANNER: {
          const yaParams = {
            banners_ev_: {
              view: {
                shop_main: [
                  {
                    position: {
                      [`static_${data.index}`]: {
                        [data.title]: data.url,
                      },
                    },
                  },
                ],
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.CLICK_MAIN_STATIC_BANNER: {
          const yaParams = {
            banners_ev_: {
              click: {
                shop_main: [
                  {
                    position: {
                      [`static_${data.index}`]: {
                        [data.title]: data.url,
                      },
                    },
                  },
                ],
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.SHOW_MAIN_SUBSCRIBER_BANNER: {
          const yaParams = {
            banners_ev_: {
              view: {
                shop_main: [
                  {
                    position: {
                      [`static_subscribe_${data.index}`]: {
                        [data.title]: data.url,
                      },
                    },
                  },
                ],
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.CLICK_MAIN_SUBSCRIBER_BANNER: {
          const yaParams = {
            banners_ev_: {
              click: {
                shop_main: [
                  {
                    position: {
                      [`static_subscribe_${data.index}`]: {
                        [data.title]: data.url,
                      },
                    },
                  },
                ],
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_SHOW_REVIEWS: {
          const yaParams = {
            shop_pdp: {
              click_icon_reviews: data.value,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_MENU: {
          const yaParams = {
            shop_pdp: {
              click_menu: data.name,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_LINK: {
          const yaParams = {
            shop_pdp: {
              click_link: { ...data },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_WRITE_REVIEW: {
          const yaParams = {
            shop_pdp: {
              menu_review: {
                click_write_review: data.productId,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_POST_REVIEW: {
          const yaParams = {
            shop_pdp: {
              menu_review: {
                post_review: data.productId,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_TYPE: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: data.title,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_DELIVERY_PICKUP: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: {
                click_pickup: data.name,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_PICKUP_BUY_OPEN: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: {
                order_form_view: data.productId,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_PICKUP_BUY_SUCCESS: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: {
                order_form_sent: data.productId,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_PICKUP_BUY_ERROR: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: {
                order_form_error: data.errorCode,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_FOCUS: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: 'search_interact',
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_SEARCH_SHOP_INPUT_RESULT: {
          const yaParams = {
            shop_pdp: {
              menu_delivery: {
                search_result: data.value,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_VIEW_OUT_OF_STOCK_FORM: {
          const yaParams = {
            shop_pdp: {
              view_form_sooninstock: { ...data },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_SUCCESS_OUT_OF_STOCK_FORM: {
          const yaParams = {
            shop_pdp: {
              sent_form_sooninstock: { ...data },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_CLICK_INSTALLMENT: {
          const yaParams = {
            shop_pdp: {
              menu_installment: data.value,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_ADD_TO_CART:
        case types.EVENT_COMMON_ADD_TO_CART:
        case types.EVENT_PRODUCT_ADD_TO_CART: {
          let yaParams = {
            'add-to-cart': {
              PDP: {
                [data?.itemType || ITEM_TYPE.PRODUCT]: data?.name,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);

          if (data?.itemType === ITEM_TYPE.SERVICE) {
            yaParams = {
              shop_pdp: {
                menu_services: data?.title,
              },
            };

            ym(counter, paramsFuncName, yaParams);
          }

          break;
        }
        case types.EVENT_NAVIGATION_ITEM_CLICK: {
          const yaParams = {
            top_menu_ev_: {
              shop_main: {
                click: {
                  [data.position + 1]: {
                    [data?.name]: data?.url,
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_NAVIGATION_ITEM_VIEW: {
          const yaParams = {
            top_menu_ev_: {
              shop_main: {
                view: data?.map((item) => ({
                  [item.position + 1]: {
                    [item?.name]: item?.url,
                  },
                })),
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SUBSCRIPTION_VIEW: {
          const yaParams = {
            form_name: {
              subscription: {
                banner: {
                  view: getPathname(),
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SUBSCRIBE_SUCCESS: {
          const yaParams = {
            form_name: {
              subscription: {
                banner: {
                  success: getPathname(),
                },
              },
            },
          };

          ym(counter, reachGoalFuncName, subscriprionSuccessName);
          ym(reachCounterCommon, reachGoalFuncName, subscriprionSuccessName);
          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SIMPLE_RECOMMENDS_VIEW: {
          const yaParams = {
            recomblock_ev_: {
              [`Советуем посмотреть_${data?.items?.[0]?.activeCategoryTitle}`]: {
                view: data?.items?.map((item) => ({
                  [item?.brandName]: {
                    [item?.name]: {
                      [item?.article]: {
                        [item.index + 1]: '/shop/',
                      },
                    },
                  },
                })),
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SIMPLE_RECOMMENDS_DEVICE_CLICK: {
          const yaParams = {
            recomblock_ev_: {
              [`Советуем посмотреть_${data?.activeCategoryTitle}`]: {
                click: {
                  [data?.brandName]: {
                    [data?.name]: {
                      [data?.article]: {
                        [data.index + 1]: '/shop/',
                      },
                    },
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SIMPLE_RECOMMENDS_TAB_CLICK: {
          const yaParams = {
            recomblock_ev_: {
              [`Советуем посмотреть_${data?.activeCategoryTitle}`]: {
                select: '/shop/',
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SIMPLE_RECOMMENDS_BANNER_CLICK: {
          const yaParams = {
            recomblock_ev_: {
              [`Советуем посмотреть_${data?.activeCategoryTitle}`]: {
                showall: '/shop/',
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_SIMPLE_RECOMMENDS_GO_TO_BASKET_CLICK: {
          const yaParams = {
            recomblock_ev_: {
              [`Советуем посмотреть_${data?.activeCategoryTitle}`]: {
                gotocart: {
                  [data?.brandName]: {
                    [data?.name]: {
                      [data?.article]: {
                        [data.index + 1]: '/shop/',
                      },
                    },
                  },
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_BNPL: {
          const yaParams = {
            bnpl: {
              pdp_view: {
                ...data,
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_PRODUCT_DETAILS_HOVER_BNPL_TOOLTIP: {
          const yaParams = {
            shop_pdp: {
              click_link: {
                pdp: 'bnpl_tooltip',
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_BNPL_TOOLTIP_LEARN_MORE: {
          const yaParams = {
            shop_pdp: {
              click_link: {
                pdp: 'bnpl_tooltip_learn_more',
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_ADD_TO_CART_WITH_BNPL: {
          const yaParams = {
            bnpl: {
              product_add: {
                ...data,
              },
            },
          };
          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCTS_SEEN_WITH_BNPL: {
          const yaParams = {
            bnpl: {
              product_view: {
                [data.url]: data.items?.map((item) => ({
                  productid: item.id,
                  name: item.title,
                })),
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCTS_SEEN_WITH_INSTALLMENT: {
          const yaParams = {
            product_credit: {
              ...getCommonFields(),
              action: 'view',
              item_type: 'list',
              list_content: data.items?.map((item) => ({
                product_id: item.id,
                product_name: item.title,
              })),
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_ADD_PRODUCT_WITH_INSTALLMENT_TO_BASKET: {
          const yaParams = {
            product_credit: {
              ...getCommonFields(),
              action: 'click',
              item_type: 'button',
              ...data,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCT_DETAILS_OPEN_WITH_INSTALLMENT: {
          const yaParams = {
            product_credit: {
              ...getCommonFields(),
              action: 'view',
              item_type: 'screen',
              ...data,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_NESTED_COLLECTION_ITEM_VIEW: {
          const yaParams = {
            menu: {
              shop_tags_view: [
                {
                  [data.index + 1]: data?.title,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_NESTED_COLLECTION_ITEM_CLICK: {
          const yaParams = {
            menu: {
              shop_tags_click: [
                {
                  [data.index + 1]: data?.title,
                },
              ],
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_FILTER_SELECT: {
          const yaParams = {
            filter: {
              filter_shop_select: {
                [data.title]: {
                  items: data.items,
                  filters: data.filters,
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_FILTER_CLEAR: {
          const yaParams = {
            filter: {
              filter_shop_clear: {
                [data.title]: {
                  items: data.items,
                  filters: data.filters,
                },
              },
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCTS_SEEN_WITH_BADGES: {
          const yaParams = {
            shop_markers: data?.items?.map((item) => ({
              page_path: window?.location?.pathname,
              action: 'view',
              id: item?.article,
              marker_text: item?.badges?.[0]?.title,
              block_name: 'listing',
            })),
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_CATALOG_PRODUCT_CLICK_WITH_BADGES: {
          const yaParams = {
            shop_markers: {
              page_path: window?.location?.pathname,
              action: 'click',
              id: data?.article,
              marker_text: data?.badges?.[0]?.title,
              block_name: 'listing',
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_MAIN_RECOMMENDS_SEEN_WITH_BADGES: {
          const yaParams = {
            shop_markers: data?.items?.map((item) => ({
              page_path: window?.location?.pathname,
              action: 'view',
              id: item?.article,
              marker_text: item?.promoBadges?.[0]?.children,
              tab_text: item?.activeCategoryTitle,
            })),
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        case types.EVENT_MAIN_RECOMMENDS_CLICK_WITH_BADGES: {
          const yaParams = {
            shop_markers: {
              page_path: window?.location?.pathname,
              action: 'click',
              id: data?.article,
              marker_text: data?.promoBadges?.[0]?.children,
              tab_text: data?.activeCategoryTitle,
            },
          };

          ym(counter, paramsFuncName, yaParams);
          break;
        }
        default:
          return false;
      }
    } catch (e) {
      console.warn(`An error occurred while trying to push '${type}' to YM e = `, e);
    }
  }
  return true;
}
